import {
    DeleteTranslatedSubtitleArgs,
    EditMassTranslatedSubtitleArgs,
    EditMassTranslatedSubtitleResponse,
    EditTranslatedSubtitleArgs,
    TranslateSubtitleArgs,
} from "./types";
import { FAST_API_URL, postOptions } from "../index";
import { throwIfNotOk } from "./httpErrors";

// Каждая обёртка смотрит на статус ответа: раньше тело ошибки (`{detail}`) возвращалось как
// данные, и редактор считал несохранённое сохранённым.

export const translateSubtitleApi = async ({
    mediaId,
    overwrite,
    override_manual_only,
    ...body
}: TranslateSubtitleArgs): Promise<unknown> => {
    const response = await fetch(`${FAST_API_URL}/translate_subtitle?media=${mediaId}`, {
        ...postOptions,
        // Флаги уходят, только когда человек их подтвердил: без них тело запроса прежнее.
        body: JSON.stringify({
            ...body,
            ...(overwrite ? { overwrite: true } : {}),
            ...(override_manual_only ? { override_manual_only: true } : {}),
        }),
    });
    await throwIfNotOk(response, "translate subtitle failed");
    return response.json();
};

export const editTranslatedSubtitleApi = async ({
    mediaId,
    ...body
}: EditTranslatedSubtitleArgs) => {
    const response = await fetch(`${FAST_API_URL}/edit_translated_subtitle?media=${mediaId}`, {
        ...postOptions,
        body: JSON.stringify(body),
    });
    await throwIfNotOk(response, "edit translated subtitle failed");
    return response.json();
};

/**
 * 200 и 207 — оба ответы, которые надо прочесть: сервер кладёт отказ по каждой реплике в
 * `results[i].error` (а новый — ещё и список `failed`). Исключение — только когда не ответил
 * весь пакет.
 */
export const editMassTranslatedSubtitleApi = async ({
    mediaId,
    body,
    origin,
}: EditMassTranslatedSubtitleArgs): Promise<EditMassTranslatedSubtitleResponse> => {
    const response = await fetch(`${FAST_API_URL}/mass_edit_translated_subtitle?media=${mediaId}`, {
        ...postOptions,
        // Машинный сдвиг помечен заголовком (см. EditMassTranslatedSubtitleArgs.origin); правка
        // переводчика уходит ровно как раньше.
        ...(origin ? { headers: { ...postOptions.headers, "X-Edit-Origin": origin } } : {}),
        body: JSON.stringify(body),
    });
    await throwIfNotOk(response, "mass edit failed");
    return response.json();
};

export const deleteTranslatedSubtitle = async ({
    mediaId,
    ...body
}: DeleteTranslatedSubtitleArgs) => {
    const response = await fetch(`${FAST_API_URL}/delete_translated_subtitle?media=${mediaId}`, {
        ...postOptions,
        body: JSON.stringify(body),
    });
    await throwIfNotOk(response, "delete translated subtitle failed");
    return response.json();
};

export const createSkipSubtitleApi = async ({
    mediaId,
    ...body
}: import("./types").CreateSkipSubtitleArgs) => {
    const response = await fetch(`${FAST_API_URL}/create_skip_subtitle?media=${mediaId}`, {
        ...postOptions,
        body: JSON.stringify(body),
    });
    await throwIfNotOk(response, "create skip subtitle failed");
    return response.json();
};

/**
 * «Вернуть» реплику, снятую с озвучки (⊘): сервер снимает с неё метку `skip`. Ручка новая —
 * старый сервер её не знает, и его отказ (404 «Not Found») редактор показывает словами сервера.
 */
export const unskipSubtitleApi = async ({
    mediaId,
    ...body
}: import("./types").UnskipSubtitleArgs) => {
    const response = await fetch(`${FAST_API_URL}/unskip_subtitle?media=${mediaId}`, {
        ...postOptions,
        body: JSON.stringify(body),
    });
    await throwIfNotOk(response, "unskip subtitle failed");
    return response.json();
};
